export type ErrorCodes = {
  [key: number]: string;
};

class CustomError extends Error {
  readonly name: string;

  constructor(name: string, message?: string) {
    super(message);
    Object.setPrototypeOf(this, CustomError.prototype);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CustomError);
    }
    this.name = name;
  }
}

export interface IDappError extends CustomError {
  readonly code: number;
  message: string;
  toString(): string;
}

export abstract class DappError extends CustomError implements IDappError {
  code: number;

  message: string;

  public constructor(name: string, code: number, message?: string) {
    // takes care of stack and proto
    super(name, message);

    this.code = code;
    this.message = message || "";
  }

  toString(): string {
    return JSON.stringify({
      name: this.name,
      code: this.code,
      message: this.message,
    });
  }
}

export class RoomInitializationError extends DappError {
  protected static messages: ErrorCodes = {
    5000: "Custom",
    5001: "Invalid roomUrl provided",
    5002: "Unexpected urlsettings",
    5003: "Unauthorized roomUrl provided",
  };

  public constructor(code: number, message?: string) {
    // takes care of stack and proto
    super("RoomInitializationError", code, message);
  }

  public static fromCode(code: number, extraMessage = ""): IDappError {
    return new RoomInitializationError(
      code,
      `${RoomInitializationError.messages[code]}, ${extraMessage}`
    );
  }

  // Custom methods
  public static invalidUrl(extraMessage = ""): IDappError {
    return RoomInitializationError.fromCode(5001, extraMessage);
  }
  public static unexpectedUrlSettings(extraMessage = ""): IDappError {
    return RoomInitializationError.fromCode(5002, extraMessage);
  }
  public static unauthorizedUrl(extraMessage = ""): IDappError {
    return RoomInitializationError.fromCode(5003, extraMessage);
  }
}
